import Vue from 'vue';
import Router from 'vue-router';

// Layouts
import AppLayout from '@/layouts/AppLayout';
import SimpleLayout from '@/layouts/SimpleLayout';

// General components
import Login from '@/components/Login';
import Register from '@/components/Register';
import ForgotUsernameOrPassword from '@/components/ForgotUsernameOrPassword';
import TermsAndConditions from '@/components/TermsAndConditions';
import Error from '@/components/common/Error';
import SessionTimeout from '@/components/SessionTimeout';
import Unsubscribe from '@/components/Unsubscribe';

// Dashboard components
import Home from '@/components/dashboard/Home';
import Reports from '@/components/dashboard/Reports';
import UsageCharts from '@/components/dashboard/UsageCharts';
import Support from '@/components/dashboard/Support';
import PrinterReport from '@/components/dashboard/PrinterReport';
import Autopay from '@/components/dashboard/Autopay';
import Payment from '@/components/dashboard/Payment';
import PaymentProcessing from '@/components/dashboard/PaymentProcessing';
import PaymentManagement from '@/components/dashboard/PaymentManagement';
import Welcome from '@/components/dashboard/Welcome';
import Balance from '@/components/dashboard/Balance';
import ChangePassword from '@/components/dashboard/ChangePassword';
import Logout from '@/components/dashboard/Logout';
import UsageStatementModal from '@/components/dashboard/UsageStatementModal';
import UsagePopup from '@/components/dashboard/UsagePopup';
import Notifications from '@/components/dashboard/Notifications';
import Thermostat from '@/components/dashboard/Thermostat';
import ThermNestRegister from '@/components/dashboard/ThermNestRegister';
import UsageStatementMobile from '@/components/dashboard/UsageStatementMobile';
import Reconnect from '@/components/dashboard/Reconnect';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: '/Portal/customer/',
  routes: [
    {
      path: '/',
      name: 'CustomerLogin',
      component: SimpleLayout,
      children: [
        {
          path: '/login',
          alias: '/',
          name: 'Login',
          component: Login,
          meta: { announcer: 'Login' }
        },
        {
          path: '/register',
          name: 'Register',
          component: Register,
          meta: { announcer: 'Register New Account' }
        },
        {
          path: '/forgotpassword/:type',
          name: 'ForgotUsernameOrPassword',
          component: ForgotUsernameOrPassword,
          props: true,
          meta: { announcer: 'Forgot Username or Password' }
        },
        {
          path: '/printerreport',
          name: 'PrinterFriendly',
          component: PrinterReport,
          meta: { conditionalRoute: true, disableSSO: false }
        },
        {
          path: '/terms',
          name: 'TermsAndConditions',
          component: TermsAndConditions,
          meta: { announcer: 'Terms and Conditions' }
        },
        {
          path: '/usagepopup',
          name: 'UsagePopup',
          component: UsagePopup,
          meta: { conditionalRoute: true, disableSSO: false }
        },
        {
          path: '/usagestatementmodal',
          name: 'UsageStatementModal',
          component: UsageStatementModal,
          meta: { conditionalRoute: true, disableSSO: false }
        },
        {
          path: '/error',
          name: 'Error',
          component: Error,
          meta: { disableSSO: false, announcer: 'Error' }
        },
        {
          path: '/ThermNestRegister',
          name: 'ThermNestRegister',
          component: ThermNestRegister,
          meta: { conditionalRoute: true, doNotReroute: true, disableSSO: false, announcer: 'Register a new thermostat' }
        },
        {
          path: '/unsubscribe',
          name: "Unsubscribe",
          component: Unsubscribe,
          meta: { disableSSO: false, announcer: 'Email Unsubscribe' }
        }
      ]
    },
    {
      path: '/dashboard',
      name: 'CustomerDashboard',
      component: AppLayout,
      children: [
        {
          path: '/home',
          alias: '/',
          name: 'Home',
          component: Home,
          meta: { conditionalRoute: true, announcer: 'Home' }
        },
        {
          path: '/reports',
          name: 'Reports',
          component: Reports,
          meta: { conditionalRoute: true, announcer: 'Reports' }
        },
        {
          path: '/usagecharts',
          name: 'Usage',
          component: UsageCharts,
          meta: { conditionalRoute: true, announcer: 'Usage Charts' }
        },
        {
          path: '/autopay',
          name: 'Autopay',
          component: Autopay,
          meta: { conditionalRoute: true, announcer: 'Autopay' }
        },
        {
          path: '/payment',
          name: 'Payment',
          component: Payment,
          meta: { conditionalRoute: true, announcer: 'Payment Options' }
        },
        {
          path: '/paymentprocessing',
          name: 'Payment Processing',
          component: PaymentProcessing,
          meta: { conditionalRoute: true, doNotReroute: true, announcer: 'PayGo Processing payment option' }
        },
        {
          path: '/paymentmanagement',
          name: 'Payment Management',
          component: PaymentManagement,
          meta: { conditionalRoute: true, doNotReroute: true, announcer: 'PayGo Processing payment management' }
        },
        {
          path: '/support',
          name: 'Support',
          component: Support,
          meta: { announcer: 'Support Information' }
        },
        {
          path: '/welcome',
          name: 'Welcome',
          component: Welcome,
          meta: { announcer: 'Welcome page' }
        },
        {
          path: '/notifications',
          name: 'Notification',
          component: Notifications,
          meta: { conditionalRoute: true, announcer: 'Notification Contacts' }
        },
        {
          path: '/balance',
          name: 'Balance',
          component: Balance,
          meta: { conditionalRoute: true, announcer: 'Balance Information' }
        },
        {
          path: '/changepassword',
          name: 'ChangePassword',
          component: ChangePassword,
          meta: { conditionalRoute: true, announcer: 'Change Username or Password' }
        },
        {
          path: '/thermostat',
          name: 'Thermostat',
          component: Thermostat,
          meta: { conditionalRoute: true, doNotReroute: true, announcer: 'Registered Thermostats' }
        },
        {
          path: '/logout',
          name: 'Logout',
          component: Logout
        },
        {
          path: '/usagestatement',
          name: 'Usage Statement',
          component: UsageStatementMobile,
          meta: { conditionalRoute: true, doNotReroute: true }
        },
        {
          path: '/reconnect',
          name: 'Reconnect',
          component: Reconnect,
          meta: { conditionalRoute: true, doNotReroute: true, announcer: 'Reconnect Meter' }
        }
      ]
    },
    {
      path: '/sessiontimeout',
      name: 'SessionTimeout',
      component: SessionTimeout
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return savedPosition ? savedPosition : { x: 0, y: 0 };
  }
});